import { motion } from 'framer-motion'
import styled, { css } from 'styled-components/macro'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const ShareContent = styled.div<{ $isShare: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-inline: var(--container-spacing);

  ${props =>
    props.$isShare &&
    css`
      height: var(--header-height);

      ${mq.ltLarge} {
        font-weight: 700;
        margin-inline: var(--container-spacing);
        padding: 0.4em 0;
        width: calc(100% - 2 * var(--container-spacing));
        justify-content: start;
        border-top: 1px solid #ccc;
      }

      ${mq.large} {
        position: absolute;
        right: 0;
        justify-content: end;
      }
    `}

  ${mq.large} {
    display: contents;
  }
`

export const ShareIntro = styled.span`
  ${mq.large} {
    display: none;
  }
`

export const ShareContainer = styled(motion.div)<{
  $spacing: 'small' | 'large'
  $isShare?: boolean
}>`
  display: flex;
  justify-content: center;
  overflow: hidden;
  gap: ${props => (props.$spacing === 'small' ? '0.7rem' : '1.5rem')};

  ${props =>
    props.$isShare &&
    css`
      &::before,
      &::after {
        content: '';
        display: block;
        padding-right: 1rem;
      }
    `}
`

export const Button = styled(motion.a)`
  display: block;
  font-size: 3.6rem;
  color: inherit;
  border-radius: 50%;

  svg {
    display: block;
  }
`

export const ShareToggle = styled.button`
  ${styleReset}
  font-size: 2rem;
  cursor: pointer;
  transition: color 0.2s;

  ${mq.ltLarge} {
    display: none;
  }

  &:hover,
  &:focus-visible {
    color: ${theme.colors.text}99;
  }

  svg {
    display: block;
  }
`
